// @ts-ignore
import {CirclePicker} from 'webtic-react-color'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import cssMobile from '../../css/editorMobile.module.css'
import IconButton from './IconButton'
import {ProductColor} from '../../models/dto/common/productColor'
import {Page} from '../../models/editor/page'
import {useTranslation} from 'react-i18next'

interface HamburgerMenuProps {
  isMenuOpen: boolean
  onClose: () => void
  colors: ProductColor[]
  colorHandler: [ProductColor | undefined, (color: ProductColor) => void]
  pages: Page[]
  selectedPageIndex: number | undefined
  setSelectedPageIndex: React.Dispatch<React.SetStateAction<number | undefined>>
  sizes: string[] | null
  selectedSize: string
  setSelectedSize: (size: string) => void
}

export default function HamburgerMenu({
  isMenuOpen,
  onClose,
  colors,
  colorHandler,
  pages,
  selectedPageIndex,
  setSelectedPageIndex,
  sizes,
  selectedSize,
  setSelectedSize,
}: HamburgerMenuProps) {
  const {t} = useTranslation()
  const [color, onColorChange] = colorHandler

  return (
    <div
      className={`${cssMobile.hamburgerContainer} ${
        isMenuOpen ? '' : cssMobile.menuClosed
      }`}>
      <div className={cssMobile.overlay} onClick={onClose}></div>
      <div className={cssMobile.menuArea}>
        <IconButton
          icon={faPlus}
          color="primary"
          onClick={onClose}
          className={cssMobile.closeHamburgerMenu}
        />
        <div className={cssMobile.menuSection}>
          <div className={cssMobile.title}>
            <span>{t('Szín')}</span>
          </div>
          <CirclePicker
            colors={colors as unknown as string[]}
            color={color as unknown as string}
            onChange={(newColor: any) => {
              const realColor = colors.find(c => c.color === newColor.hex)
              if (realColor) {
                onColorChange(realColor)
              }
            }}
            width="230px"
          />
        </div>
        {sizes && sizes.length > 1 ? (
          <div className={cssMobile.menuSection}>
            <div className={cssMobile.title}>
              <span>{t('Méret')}</span>
            </div>
            <select
              className={cssMobile.input}
              value={selectedSize}
              onChange={e => {
                setSelectedSize(e.target.value)
              }}>
              {sizes.map(size => (
                <option key={`productSizesMobile-${size}`} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>
        ) : null}

        {pages.length > 0 && selectedPageIndex !== undefined ? (
          <div className={cssMobile.menuSection}>
            <div className={cssMobile.title}>
              <span>{t('Oldal')}</span>
            </div>
            <select
              className={cssMobile.input}
              value={selectedPageIndex}
              onChange={e => {
                setSelectedPageIndex(Number(e.target.value))
              }}>
              {pages.map((page, index) => (
                <option key={`productPagesMobile-${index}`} value={index}>
                  {t(page.text)}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        <button onClick={onClose} className="editorButton">
          {t('Szerkesztés')}
        </button>
      </div>
    </div>
  )
}
